import { render, staticRenderFns } from "./MenuToolBar.vue?vue&type=template&id=a47b1cc4&scoped=true&"
import script from "./MenuToolBar.vue?vue&type=script&lang=js&"
export * from "./MenuToolBar.vue?vue&type=script&lang=js&"
import style0 from "./MenuToolBar.vue?vue&type=style&index=0&id=a47b1cc4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47b1cc4",
  null
  
)

export default component.exports